/* eslint-disable react/display-name */
/* eslint-disable sonarjs/cognitive-complexity */
import * as React from 'react';
import {useContext} from 'react';
import {TPAComponentsProvider} from '@wix/wix-ui-tpa/cssVars';
import {useSettings, useStyles} from '@wix/tpa-settings/react';
import settingsParams from './components/GridGallery/settingsParams';
import {useStylesParams} from './stylesParamsContext';
import {useExperiments} from '@wix/yoshi-flow-editor';
import {IGlobals} from './gallery/galleryGlobalStrategy';
import {Experiments} from './constants';

let Provider;
let Consumer;
let globalsContext;
let strategy: (props: any) => {globals: any; locals: any};

export type Strategy<T> = (props: any) => {globals: T; locals: any};

export function withGlobalsProvider(Component, sliderGallery) {
  return (props) => {
    const {
      globals,
      locals,
      globals: {shouldShowMobile, isMobile, isRTL},
    } = strategy(props);

    globals.styles = useStyles();
    globals.stylesParams = useStylesParams();
    globals.useExperiments = useExperiments().experiments;
    const isAddSliderGalleryTitleToGlobalPropsContextExperimentEnabled = globals.useExperiments.enabled(
      Experiments.AddSliderGalleryTitleToGlobalPropsContext
    );

    if (globals.textsMap) {
      const {get: getSettings} = useSettings();

      if (!sliderGallery) {
        globals.textsMap.loadMoreButtonText =
          getSettings(settingsParams.LOAD_MORE_BUTTON) || globals.textsMap.loadMoreButtonText;
        globals.textsMap.loadPreviousButtonText =
          getSettings(settingsParams.gallery_loadPreviousText) || globals.textsMap.loadPreviousButtonText;
        globals.textsMap.filtersTitleText =
          getSettings(settingsParams.FILTERS_MAIN_TITLE) || globals.textsMap.filtersTitleText;
        globals.textsMap.sortTitleText =
          getSettings(settingsParams.SORTING_MAIN_TITLE) || globals.textsMap.sortTitleText;
        globals.textsMap.sortLabel = getSettings(settingsParams.SORTING_MAIN_TITLE) || globals.textsMap.sortLabel;
      }

      globals.textsMap.addToCartOutOfStock =
        getSettings(settingsParams.gallery_oosButtonText) || globals.textsMap.addToCartOutOfStock;
      globals.textsMap.galleryAddToCartButtonText =
        getSettings(settingsParams.gallery_addToCartText) || globals.textsMap.galleryAddToCartButtonText;
      globals.textsMap.galleryAddToCartPreOrderButtonText =
        getSettings(settingsParams.gallery_preOrderText) || globals.textsMap.galleryAddToCartPreOrderButtonText;
      globals.textsMap.categoryTreeTitle =
        getSettings(settingsParams.categoryTreeTitle) || globals.textsMap.categoryTreeTitle;
      globals.textsMap.selectOptionsButtonText =
        getSettings(settingsParams.gallery_selectOptionsButtonText) || globals.textsMap.selectOptionsButtonText;

      /* istanbul ignore else: related to Editor 3 live text editing for the slider title, hard to test */
      if (isAddSliderGalleryTitleToGlobalPropsContextExperimentEnabled) {
        globals.textsMap.sliderGalleryTitle =
          getSettings(settingsParams.SLIDER_GALLERY_TITLE_COLLECTION) || globals.textsMap.sliderGalleryTitle;
      }
    }

    return (
      <Provider value={globals}>
        <TPAComponentsProvider value={{mobile: shouldShowMobile || isMobile, rtl: isRTL}}>
          <Component {...locals} />
        </TPAComponentsProvider>
      </Provider>
    );
  };
}

export const withGlobals = (Component): any => {
  return (props) => {
    return <Consumer>{(globals) => <Component globals={globals} {...props} ref={props.innerRef} />}</Consumer>;
  };
};

export function useGlobals() {
  return useContext<IGlobals>(globalsContext);
}

export function initContext<T>(aStrategy: Strategy<T>) {
  globalsContext = React.createContext<T>(undefined);
  strategy = aStrategy;
  Provider = globalsContext.Provider;
  Consumer = globalsContext.Consumer;
}
